<div class="chat-header">
  <span class="pointer" (click)="restartConversation()">
    @if (agentCard?.title) {
    {{ agentCard.title }}
    } @else { Reiniciar conversación }
  </span>

  @for (conversation of alternativeConversation; track conversation._id) {
  <span class="pointer" (click)="restartConversation(conversation)"> {{ conversation.title }} </span>
  }

  <div class="header-controls">
    @if (isAdmin()){
    <div class="admin-controls">
      <i style="color: rgb(255, 149, 0)" class="pi pi-key"></i>

      <p-button variant="text" [raised]="true" icon="pi pi-id-card" (click)="showInfo()"></p-button>

      <!-- <span class="pointer" (click)="showInfo()"> ⚡️ </span> -->
    </div>
    }

    <div>
      <span class="pointer" (click)="settingsClick()"> ⚙️ </span>
    </div>
  </div>
</div>
